import { jsx as o } from "react/jsx-runtime";
import { aB as t } from "../../vendor-Dd6qj6gJ.js";
import "react";
import "../../theme/spacing.js";
import { omitStyleRenderProps as e } from "../../utils/omitStyleRenderProps/index.js";
import '../../assets/index27.css';const i = "_fieldError_taatg_1", f = {
  fieldError: i
};
function d(r) {
  return /* @__PURE__ */ o(
    t,
    {
      ...e(r),
      className: f.fieldError,
      "data-component": "FieldError"
    }
  );
}
export {
  d as FieldError
};
